import HeroSection         from '../components/sections/HeroSection';
import TrustedBySection    from '../components/sections/TrustedBySection';
import HowItWorksSection   from '../components/sections/HowItWorksSection';
import FeaturesSection     from '../components/sections/FeaturesSection';
import IntegrationsSection from '../components/sections/IntegrationsSection';
import CompareSection      from '../components/sections/CompareSection';
import PricingSection      from '../components/sections/PricingSection';
import TestimonialsSection from '../components/sections/TestimonialsSection';
import FaqSection          from '../components/sections/FaqSection';
import CtaSection          from '../components/sections/CtaSection';
import SEO                 from '../components/SEO';

const HOME_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: 'Zepliq',
  url: 'https://zepliq.com',
  applicationCategory: 'BusinessApplication',
  operatingSystem: 'Web',
  description: 'AI-powered WhatsApp automation platform. Automate conversations, capture leads, confirm orders, and manage your sales pipeline 24/7.',
  aggregateRating: { '@type': 'AggregateRating', ratingValue: '4.9', reviewCount: '512' },
};

export default function HomePage({ onWatchDemo }) {
  return (
    <>
      <SEO
        title="AI WhatsApp Automation Platform — Automate Sales & Support 24/7"
        description="Zepliq automates WhatsApp and email conversations with AI. Capture leads, confirm Shopify/WooCommerce orders, reply 24/7. Trusted by 5,000+ businesses in 40+ countries."
        keywords="WhatsApp automation, AI WhatsApp chatbot, WhatsApp business bot, WhatsApp CRM, Shopify WhatsApp integration, WooCommerce WhatsApp bot, WhatsApp lead generation, automate WhatsApp messages, WhatsApp sales automation, Zepliq"
        canonical="/"
        structuredData={HOME_SCHEMA}
      />
      <HeroSection onWatchDemo={onWatchDemo} />
      <TrustedBySection />
      <HowItWorksSection />
      <FeaturesSection />
      <IntegrationsSection />
      <CompareSection />
      <PricingSection />
      <TestimonialsSection />
      <FaqSection />
      <CtaSection />
    </>
  );
}
